// Descrizione: contiene i servizi per la gestione delle configurazioni.
import { HTTP } from "api";

// Percorso di base per le chiamate API relative alle configurazioni
const basePath = "/admin/feedback/";
const basePathArguments = "/admin/feedback/arguments";

// Oggetto che esporta i metodi per interagire con le API di gestione delle configurazioni
export default {
  // Metodo per ottenere i dettagli di una configurazione dato l'ID
  getDetail(id) {
    return HTTP.get(basePath.concat(id));
  },

  // Metodo per ottenere una lista paginata di configurazioni
  getList(
    currentPage,
    pageSize,
    sortColumn,
    sortOrder,
    filter,
    other,
    customFilters
  ) {
    // Componente paginazione è basato su base 0, API su base 1
    currentPage = currentPage + 1;

    // Parametri da includere nella richiesta API
    let params = {
      currentPage,
      pageSize,
      sortColumn,
      sortOrder,
      filter,
    };

    params = { ...params, ...other };

    for (let i = 0; i < customFilters.length; i++) {
      let filtro = customFilters[i];
      params[filtro.filter] = filtro.value;
    }

    return HTTP.get(basePath, { params });
  },
  // Metodo per segnare un feedback come non letto
  unReadFeedback(id) {
    const data = {
      status: 0,
    };
    return HTTP.put(`${basePath}${id}`, data);
  },

  // Metodo per aggiornare lo stato di lettura di un feedback
  updateReadStatus(id) {
    return HTTP.put(`${basePath}${id}`);
  },

  addFeedback(detail) {
    return HTTP.post(basePath, detail);
  },

  getArgumentList(p) {
    // return HTTP.get(
    //   "https://localhost:44492/mock/feedbackMock.json"
    // );
    return HTTP.get(basePathArguments, { params: { context: p } });
  },

  // Metodo per aggiornare i dettagli di una configurazione
  updateDetail(id, data) {
    return HTTP.put(basePath + id, data);
  },

  // Metodo per aggiungere una nuova configurazione
  addDetail(data) {
    return HTTP.post(basePath, data);
  },

  // Metodo per eliminare una configurazione dato l'ID
  deleteDetail(id) {
    // debugger
    return HTTP.delete(basePath.concat(id));
  },
};
